export function brandRedirectParts(path: string) {
  const match = /^\/catalog\/brands\/([1-9]\d*)(\/(?:seeds|reviews))?\/?([?#].*)?$/.exec(path);
  return match ? { id: match[1], suffix: `${match[2] || ''}${match[3] || ''}` } : null;
}
